import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ProviderStatus } from '@/lib-backend';
import { RealmService } from '@/app/services/realm.service';

@Component({
    standalone: true,
    selector: 'app-needs-attention-widget',
    template: `
        @if (alerts().length > 0) {
            <div class="card flex flex-col gap-3 border-l-4 border-orange-500">
                <div class="flex items-center gap-2 font-semibold text-lg">
                    <i class="pi pi-exclamation-triangle text-orange-500"></i>
                    <span>Needs attention</span>
                </div>
                <div class="flex flex-col divide-y divide-surface-200 dark:divide-surface-700">
                    @for (alert of alerts(); track alert.label) {
                        <button
                            type="button"
                            class="flex items-center justify-between gap-3 py-3 hover:bg-surface-50 dark:hover:bg-surface-800 -mx-3 px-3 rounded text-left"
                            (click)="alert.onClick()"
                        >
                            <div class="flex items-center gap-3">
                                <i [class]="alert.icon" [style.color]="alert.color"></i>
                                <span class="text-sm">{{ alert.label }}</span>
                            </div>
                            <i class="pi pi-chevron-right text-muted-color text-xs"></i>
                        </button>
                    }
                </div>
            </div>
        }
    `
})
export class NeedsAttentionWidget {
    private readonly router = inject(Router);
    private readonly realmService = inject(RealmService);

    private readonly providerIssueCount = computed(() =>
        this.realmService.realms().filter(r =>
            r.ProviderStatus === ProviderStatus.NotConfigured
            || r.ProviderStatus === ProviderStatus.Unavailable
        ).length
    );

    protected readonly alerts = computed(() => {
        const list: { label: string; icon: string; color: string; onClick: () => void }[] = [];

        const issues = this.providerIssueCount();
        if (issues > 0) {
            list.push({
                label: `${issues} ${issues === 1 ? 'website has' : 'websites have'} game-server issues`,
                icon: 'pi pi-exclamation-triangle',
                color: 'var(--p-red-500)',
                onClick: () => this.router.navigate(['/website']),
            });
        }

        return list;
    });
}
